import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { PromptModal, Link } from 'components'
import { useCreateInquiry } from 'api'
import { InquiryForm } from './InquiryForm'
import { useTranslation } from 'react-i18next'

export const InquiryPage = () => {
  const history = useHistory()
  const navigateToOverview = useCallback(() => history.push('/'), [history])
  const { t } = useTranslation()

  const [mutate, { status, reset }] = useCreateInquiry()
  const onSubmit = useCallback(
    (values, { setSubmitting }) => {
      mutate({ inquiry: values })
      setSubmitting(false)
    },
    [mutate]
  )

  return (
    <>
      <h1 id="inquiries-overview-title-e2e">
        {t('pages.inquiries.inquiryPage.heading')}
      </h1>
      <p>{t('pages.inquiries.inquiryPage.inquiryText')}</p>
      <p>
        {t('pages.inquiries.inquiryPage.bookingsText')}{' '}
        <Link variant="inline" to="/bookings/new">
          {t('pages.inquiries.inquiryPage.bookingsForm')}
        </Link>
        .
      </p>

      <InquiryForm onSubmit={onSubmit} />

      {status === 'success' && (
        <PromptModal
          headline={t('pages.inquiries.inquiryPage.success.heading')}
          confirmCallback={navigateToOverview}
          confirmText={t('pages.inquiries.inquiryPage.success.confirm')}
        >
          {t('pages.inquiries.inquiryPage.success.info')}
        </PromptModal>
      )}

      {status === 'failure' && (
        <PromptModal
          headline={t('pages.inquiries.inquiryPage.failure.heading')}
          confirmCallback={reset}
          confirmText={t('pages.inquiries.inquiryPage.failure.confirm')}
        >
          {t('pages.inquiries.inquiryPage.failure.info')}
        </PromptModal>
      )}
    </>
  )
}
